<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row(v-if="!loading")
    v-col.py-0
      v-card.elevation-6.mb-5(style="overflow: hidden")
        app-full-entity(
          :entity="fullSortedEntity",
          :customLoads="searchLoads",
          :ignoreTabs="ignorableTabs",
          v-bind="{ customLabel, tabsWithErrors }"
        )
          template(v-slot:Quote="props")
            quote-general(:slotProps="props", v-bind="{ errors, loading, uid }")
            template(v-for="section in orderedSections(props.sections)")
              slot(v-if="section.name === 'businessScope'")
                app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)")
              slot(v-if="section.name === 'quoteItems'")
                quote-items(:entity="$findEntity(section.type)", :relation="section", :path="section.name", :parent-instance="instance")

  v-row.pl-5(v-if="entity", v-show="!loading", align="center")
    v-col.py-0(cols="12")
      g-btn.mr-3.white--text.float-right(:disabled="disableSubmit", color="geoGreen", @click="save", width="131") {{ $t('Common.save') }}
      g-btn.mr-3.float-right(color="error", outlined, @click="redirectToIndex", width="100") {{ $t('Common.cancel') }}
</template>

<style lang="scss" scoped>
.error {
  background-color: red !important;
}

.v-card{
  min-height: 350px;
}
</style>

<script>
import axios from "axios";
import _ from "lodash";
import EntityMixin from "@/mixins";
import QuoteGeneral from "@/components/Quote/General";

export default {
  mixins: [EntityMixin],
  name: "quote-add",
  components: {
    QuoteGeneral,
  },
  data: function () {
    return {
      activeTab: null,
      errors: {},
      tabsWithErrors: [],
      disregardErrorInTabs: [],
      loading: true,
      permIgnore: ["status"],
      orderedFields: ["Quote", "shipment"],
      loads: ["Shipment", "QuoteItems","QuoteItems.ExtraData", "Status", "User", "ExtraData"],
      searchLoads: { shipment: ["Quotes"] },
      sections: {
        quoteItems: "Quote"
      }
    };
  },
  computed: {
    customLabel() {
      return ({
        Quote: this.$t('Common.general'),
        shipment: this.$tc('Shipment._name', 1),
      });
    },
    entityName() {
      return "Quote";
    },
    entity() {
      return this.$findEntity("Quote");
    },
    uid() {
      return this.$route.params.item;
    },
    fullSortedEntity() {
        let sortedData = this.$sortFields([...this.entity.fields], this.orderedFields);

        let entityClone = _.cloneDeep(this.entity);
        entityClone.fields = sortedData;
        entityClone.fields = this.$sectionedFields(entityClone, this.sections);
        return entityClone;

    },
    ignorableTabs() {
      return this.permIgnore;
    },
    disableSubmit() {
      return this.instace && this.instance.status ? this.instance.status.blockEdit : false;
    },
  },
  methods: {
    orderedSections(sections) {
      return (sections || []).filter(x => x.section === this.fullSortedEntity.name || x.section === this.fullSortedEntity.tabLabel).reverse();
    },
    errorInTab({ name }) {
      return this.tabsWithErrors.some((e) => e == name);
    },
    disregardErrorInTab(tabindex) {
      return this.disregardErrorInTabs.some((e) => e == tabindex);
    },
    formatedErrors(relation) {
      if (this.disableErrorTabs) return [];
      return Object.keys(
        this.$formatErrors(this.$store.state.errors, relation)
      );
    },
    findTabErrors(errors, relation) {
      console.log("evaluating errors", this.$cleanString(errors), this.$cleanString(relation));
      // TODO
      // find fields in relation that has the name of the error
      // return those errors that matches fields in the relation
      return errors;
    },
    getLabel(val) {
      var labelAttribute = val.tabLabel || val.name;
      if (!labelAttribute) return "";
      labelAttribute = labelAttribute.replace(/\_[\d]+/, "");
      let customLabelObject = this.customLabel;
      //If the customLabel prop is empty and the entity has customLabel property on the projectConfig, use them
      if (_.isEmpty(customLabelObject) && this.$getCustomLabel(this.entity.name)) {
        customLabelObject = this.$getCustomLabel(this.entity.name);
      }
      return this.$displayName(_.get(customLabelObject, labelAttribute, labelAttribute));
    },
    getEntityRelation(relation) {
      const { type, extra } = relation;
      if (this.portal && extra) return relation;
      return this.$findEntity(type);
    },
    /**
     * Go back to the quotes index
     */
    redirectToIndex() {
      this.$router.push({
        name: "entities.index",
        params: { entity: this.entity.name },
      });
    },
    /**
    Get Business Scope according to the businessScopeId given
    */
    async getBusinessScope(businessScopeId) {
      if (businessScopeId == null) return null;
      let bs = (await axios.get("BusinessScope?where[]=id=" + businessScopeId)).data.data;
      return bs[0];
    },

    /**
    Map the errors on the entity fields
    TODO: fix all the routes of possible errors.
    */
    mapErrors(errors = {}) {
      this.tabsWithErrors = [];
      const rootFields = [
        "customerReference",
        "rateCard",
        "currency",
        "quoteItems",
      ];
      if (_.keys(errors).some((r) => _.some(rootFields, (v) => r.includes(v))))
        this.tabsWithErrors.push("Quote");
    },
    /**
     * Save the Quote into database using graph API.
     * **/
    async save() {
      try {
        this.loading = true;
        //Set the business scope if user didn't select any.
        if (this.instance.businessScope == null || this.instance.businessScopeId === null)
          this.instance.businessScopeId = this.$getBusinessScopeId();

        //Change entity state for shipment to avoid validation errors
        if(this.instance.shipment)
            this.instance.shipment.entityState = 0;

        //Send the http post request
        this.instance = (await axios.post("entity/graph", this.instance)).data;
        //If success, return to index
        this.redirectToIndex();
      } catch (error) {
        const requestErrors = _.get(error, "response.data.errors");
        if (requestErrors) {
          this.errors = error.response.data.errors;
          this.mapErrors(requestErrors);
        }
        console.log(`[Quote][save] error: `, this.$cleanString(error));
      } finally {
        this.loading = false;
      }
    },
    async load() {
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true, ...this.loads);
          let _instance = (await axios.get(endpoint, { _Entity: this.entity.name, uid: this.uid })).data;

          this.instance = _instance;
          this.instance.entityState = 3;

          const { status } = this.instance;
          ({ blockEdit: this.blockEdit } = status || {});
        } catch (error) {
          console.error(error);
        }
      }
    },
  },
    async created() {
      const lsbusinessScopeId = window.localStorage.getItem("BusinessScopeId");
      const lsbusinessScope = await this.getBusinessScope(lsbusinessScopeId);

      this.$store.commit("SET_INSTANCE", {
        entityState: 4,
        _Entity: this.entity.name,
        user: this.$store.state.user.user,
        businessScopeId: lsbusinessScopeId,
        businessScope: lsbusinessScope,
        quoteItems: [{ uid: this.$generateUid(), entityState: 4, _Entity: 'QuoteItem', subtotal: 0 }],
      });
      await this.load();
      this.loading = false;
    },
    async mounted () {
        //Check if the quote creation comes from PendingTasks by looking for the ExternalID Query parameter

        //Case 1: Shipment (s)
        if (this.$route.query.s) {
            let sentShipment = (await axios.get(`shipments?where[]=x => x.externalId = "${this.$route.query.s}"`)).data.data;
            if(sentShipment && sentShipment.length > 0){
                this.instance.shipment = sentShipment[0];
                this.instance.shipmentId = sentShipment[0].id;
            }
        }
        //Case 2: Order (o)
        //TODO: implementation when Orders quotes are added.
        if(this.$route.query.o) {

        }
        //Case 3: Orderline (ol)
        //TODO: implementation when Orderlines quotations are added.
        if(this.$route.query.ol) {

        }
    }
};
</script>
